import { render } from "./ProfileLoader.vue?vue&type=template&id=dd260d26"
import script from "./ProfileLoader.vue?vue&type=script&lang=js"
export * from "./ProfileLoader.vue?vue&type=script&lang=js"

import "./ProfileLoader.vue?vue&type=style&index=0&id=dd260d26&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__